import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  PaymentJournalData,
  PaymentJournalPrintRequest,
  PaymentJournalPrintResponse,
  PaymentJournalSearchRequest
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/payment-journal`;

export const searchPaymentJournal = (
    paymentJournalSearchRequest: PaymentJournalSearchRequest,
    source: CancelTokenSource): Promise<PaymentJournalData> => {
  return axios
      .post(`${apiUri}/search`, paymentJournalSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const getPaymentJournalPrintPreview = (billJournalPrintRequest: Partial<PaymentJournalPrintRequest>,
                                           source: CancelTokenSource): Promise<PaymentJournalPrintResponse> => {
  return axios
      .post(`${apiUri}/output`, billJournalPrintRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getPaymentJournalPdfUrl = (paymentJournalPdfId: string, paymentJournalPdfName: string) => {
  return `${baseUrl}/e355ee1f16324ef79ce581731034308a/${paymentJournalPdfId}/${paymentJournalPdfName}`;
};
